import React, { memo } from "react";
import NodeWrapper from "./NodeWrapper";
import { HourglassEmpty, Webhook, CalendarMonth } from "@mui/icons-material";

/**
 * Wait Node — Aguardar por tempo, data ou evento (nao-bloqueante).
 *
 * data.waitType: "time" | "date" | "webhook"
 *   - time:    data.waitAmount (number) + data.waitUnit ("seconds"|"minutes"|"hours"|"days")
 *   - date:    data.waitUntil (ISO datetime)
 *   - webhook: data.waitWebhookId (string) — aguarda callback externo
 *
 * Saida: handle "a" (default, apos espera)
 */
const UNIT_LABELS = {
  seconds: "segundo(s)",
  minutes: "minuto(s)",
  hours: "hora(s)",
  days: "dia(s)",
};

const WaitNode = memo(({ id, data, isConnectable, selected }) => {
  const waitType = data?.waitType || "time";
  const amount = data?.waitAmount ?? data?.seconds ?? "";
  const unit = data?.waitUnit || data?.unit || "seconds";
  const untilDate = data?.waitUntil || "";

  const renderContent = () => {
    if (waitType === "time") {
      return (
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "#E8EAF6", border: "1px solid #C5CAE9",
          borderRadius: 16, padding: "4px 12px",
        }}>
          <HourglassEmpty style={{ fontSize: 14, color: "#3949AB" }} />
          <span style={{ fontSize: 13, fontWeight: 600, color: "#1A237E" }}>
            {amount ? `${amount} ${UNIT_LABELS[unit] || unit}` : "Tempo nao definido"}
          </span>
        </div>
      );
    }
    if (waitType === "date") {
      let dateStr = "Data nao definida";
      if (untilDate) {
        try {
          const d = new Date(untilDate);
          dateStr = d.toLocaleString("pt-BR", {
            day: "2-digit", month: "2-digit", year: "numeric",
            hour: "2-digit", minute: "2-digit",
          });
        } catch { dateStr = untilDate; }
      }
      return (
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "#E8EAF6", border: "1px solid #C5CAE9",
          borderRadius: 16, padding: "4px 12px",
        }}>
          <CalendarMonth style={{ fontSize: 14, color: "#3949AB" }} />
          <span style={{ fontSize: 12, fontWeight: 600, color: "#1A237E" }}>
            {dateStr}
          </span>
        </div>
      );
    }
    // webhook
    return (
      <div style={{
        display: "inline-flex", alignItems: "center", gap: 6,
        background: "#E8EAF6", border: "1px solid #C5CAE9",
        borderRadius: 16, padding: "4px 12px",
      }}>
        <Webhook style={{ fontSize: 14, color: "#3949AB" }} />
        <span style={{ fontSize: 12, fontWeight: 600, color: "#1A237E" }}>
          Aguardar evento externo
        </span>
      </div>
    );
  };

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<HourglassEmpty />}
      title="Aguardar"
      color="#3949AB"
      bgColor="#E8EAF6"
      isConnectable={isConnectable}
      selected={selected}
      minWidth={200}
    >
      {renderContent()}
    </NodeWrapper>
  );
});

WaitNode.displayName = "WaitNode";
export default WaitNode;
